import { each, forEach, startsWith, filter } from "lodash-es";
import {
  getYOffsetForPotentiallyCircularRange,
  splitRangeIntoTwoPartsIfItIsCircular
} from "@teselagen/range-utils";
export default function mapAnnotationsToRows(annotations, sequenceLength, bpsPerRow, { splitForwardReverse } = {}) {
  const annotationsToRowsMap = {};
  const yOffsetLevelMap = {};
  const wrappedAnnotations = {};
  each(annotations, (annotation) => {
    const containsLocations = !!(annotation.locations && annotation.locations.length);
    if (annotation.overlapsSelf) {
      if (!wrappedAnnotations[annotation.id]) {
        mapAnnotationToRows({
          wrappedAnnotations,
          annotation: {
            start: 0,
            end: sequenceLength - 1,
            id: `__tempAnnRemoveMe__${annotation.id}`
          },
          sequenceLength,
          bpsPerRow,
          annotationsToRowsMap,
          yOffsetLevelMap,
          containsLocations,
          splitForwardReverse
        });
        wrappedAnnotations[annotation.id] = true;
      }
    }
    mapAnnotationToRows({
      wrappedAnnotations,
      annotation,
      sequenceLength,
      bpsPerRow,
      annotationsToRowsMap,
      yOffsetLevelMap,
      containsLocations,
      splitForwardReverse
    });
    if (containsLocations) {
      annotation.locations.forEach((location) => {
        mapAnnotationToRows({
          wrappedAnnotations,
          annotation,
          sequenceLength,
          bpsPerRow,
          annotationsToRowsMap,
          yOffsetLevelMap,
          location,
          splitForwardReverse
        });
      });
    }
  });
  forEach(annotationsToRowsMap, (annotationsForRow, i) => {
    annotationsToRowsMap[i] = filter(
      annotationsForRow,
      (ann) => !startsWith(ann.id, "__tempAnnRemoveMe__")
    );
  });
  return annotationsToRowsMap;
}
function mapAnnotationToRows({
  annotation,
  sequenceLength,
  bpsPerRow,
  annotationsToRowsMap,
  yOffsetLevelMap,
  location,
  containsLocations,
  splitForwardReverse
}) {
  const ranges = splitRangeIntoTwoPartsIfItIsCircular(
    location || annotation,
    sequenceLength
  );
  ranges.forEach((range, index) => {
    const startingRow = Math.floor(range.start / bpsPerRow);
    const endingRow = Math.floor(range.end / bpsPerRow);
    for (let rowNumber = startingRow; rowNumber <= endingRow; rowNumber++) {
      if (!annotationsToRowsMap[rowNumber]) {
        annotationsToRowsMap[rowNumber] = [];
      }
      const key = splitForwardReverse ? annotation.forward ? rowNumber + "_forward" : rowNumber + "_reverse" : rowNumber;
      const annotationsForRow = annotationsToRowsMap[rowNumber];
      if (!yOffsetLevelMap[key]) {
        yOffsetLevelMap[key] = [];
      }
      let yOffset;
      const yOffsetsForRow = yOffsetLevelMap[key];
      const start = rowNumber === startingRow ? range.start : rowNumber * bpsPerRow;
      const end = rowNumber === endingRow ? range.end : rowNumber * bpsPerRow + bpsPerRow - 1;
      if (annotation.overlapsSelf) {
        annotationsForRow.forEach((ann) => {
          if (ann.id === `__tempAnnRemoveMe__${annotation.id}`) {
            yOffset = ann.yOffset;
          }
        });
      } else {
        if (location) {
          annotationsForRow.forEach((ann) => {
            if (ann.id === annotation.id) {
              yOffset = ann.yOffset;
            }
          });
        } else {
          if (index > 0 && //second half of an annotation range
          annotationsForRow.length && //there are already annotations within the row
          annotationsForRow[annotationsForRow.length - 1].annotation === annotation) {
            yOffset = annotationsForRow[annotationsForRow.length - 1].yOffset;
          } else {
            yOffset = getYOffsetForPotentiallyCircularRange(
              annotation,
              yOffsetsForRow
            );
          }
          if (!yOffsetsForRow[yOffset]) yOffsetsForRow[yOffset] = [];
          yOffsetsForRow[yOffset].push({
            start,
            end
          });
        }
      }
      annotationsForRow.push({
        id: annotation.id,
        annotation,
        start,
        end,
        ...containsLocations && { containsLocations },
        ...location && { isJoinedLocation: !!location },
        yOffset,
        enclosingRangeType: range.type
        //either "beginning", "end" or "beginningAndEnd"
      });
    }
  });
}
